export default __webpack_public_path__ + "static/media/mint-card.c8699aed.gif";